import { render, staticRenderFns } from "./PerguntasFrequentes.vue?vue&type=template&id=768a26c0&"
import script from "./PerguntasFrequentes.vue?vue&type=script&lang=js&"
export * from "./PerguntasFrequentes.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasFrequentes.vue?vue&type=style&index=0&id=768a26c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports